import {
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from '@synoptic/ui-kit/dropdown-menu/dropdown-menu.js';
import { NavArrowRightIcon } from '@synoptic/ui-kit/icons/react/nav-arrow-right.js';
import { PlusIcon } from '@synoptic/ui-kit/icons/react/plus.js';
import { FC } from 'react';
import { CustomCollection, StreamDeck } from '@/__generated__/schema-types';

export interface StreamDeckSubMenuItemProps {
  streamDecks: StreamDeck[];
  onStreamColumnSelect: (
    streamDeck: StreamDeck,
    streamDeckColumn: CustomCollection | 'new',
  ) => void;
}

export const StreamDeckSubMenuItem = ({
  streamDeck,
  onStreamColumnSelect,
}: {
  streamDeck: StreamDeck;
  onStreamColumnSelect: StreamDeckSubMenuItemProps['onStreamColumnSelect'];
}) => {
  const collections = streamDeck.collections.filter(
    (collection) => !collection.isRelatedNews,
  );

  return (
    <>
      <DropdownMenuItem
        onSelect={() => {
          onStreamColumnSelect(streamDeck, 'new');
        }}
        key="add-new-column"
        icon={<PlusIcon />}
      >
        Add new list
      </DropdownMenuItem>
      {!!collections.length && <DropdownMenuSeparator />}
      {collections.map((collection) => (
        <DropdownMenuItem
          onSelect={() => {
            onStreamColumnSelect(streamDeck, collection);
          }}
          key={collection.id}
        >
          {collection.name}
        </DropdownMenuItem>
      ))}
    </>
  );
};

export const AddToStreamDeckDropdownMenuItem: FC<
  StreamDeckSubMenuItemProps
> = ({ streamDecks, onStreamColumnSelect }) => {
  return (
    <DropdownMenuSub key="add-to-stream-deck">
      <DropdownMenuSubTrigger asChild>
        <DropdownMenuItem iconPosition="right" icon={<NavArrowRightIcon />}>
          Add to NewsDeck
        </DropdownMenuItem>
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent>
        {streamDecks.length === 1 && (
          <StreamDeckSubMenuItem
            streamDeck={streamDecks[0]}
            onStreamColumnSelect={onStreamColumnSelect}
          />
        )}
        {streamDecks.length > 1 &&
          streamDecks.map((streamDeck) => (
            <DropdownMenuSub key={streamDeck.id}>
              <DropdownMenuSubTrigger asChild>
                <DropdownMenuItem
                  iconPosition="right"
                  icon={<NavArrowRightIcon />}
                >
                  {streamDeck.name}
                </DropdownMenuItem>
              </DropdownMenuSubTrigger>
              <DropdownMenuSubContent>
                <StreamDeckSubMenuItem
                  streamDeck={streamDeck}
                  onStreamColumnSelect={onStreamColumnSelect}
                />
              </DropdownMenuSubContent>
            </DropdownMenuSub>
          ))}
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  );
};
